import 'jquery-toggles';

const SELECTOR = '[data-csn-toggles]';

const OPTIONS = {
  text: {
    on: '',
    off: ''
  },
  drag: Modernizr.touchevents
};

class Toggles {
  constructor() {
    if ($(SELECTOR).size()) {
      Toggles.initialize();
    }
  }

  static initialize() {
    const isInitialized = $(`${SELECTOR} .toggle-slide`).size();

    if (isInitialized) {
      return false;
    }

    $(SELECTOR).toggles(OPTIONS);
  }
}

export default Toggles;



// WEBPACK FOOTER //
// ./src/javascripts/Toggles.js